export default __webpack_public_path__ + "static/45-fit-c0ce486ca3146154fa8e7374bf559a65.png";